import { DamageType } from "../damageType";
import { DestroyableObstacle } from "../destroyableObstacle";
import { BigExplosion } from "../effects/bigExplosion";
import { ParticleEffect } from "../effects/particleEffect";
import { ParticleType } from "../particleType";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { Fire } from "./fire";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";

export class ExplosiveBarrel extends DestroyableObstacle {
	static key = "ExplosiveBarrel";
	constructor(xy: XY) {
		super(xy);
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		super.onZeroHp(source, type);
		const board = this.board!;
		board.addNonPhysicalThing(new Sound(SoundId.EXPLOSION, this.xy));
		board.addEffect(new BigExplosion(this.xy));
		board.addEffect(new ParticleEffect(this.xy, ParticleType.LARGE_GROUND_EXPLOSION, 30));
		board.addThing(new Fire(this.xy));
		for (const neighborXY of this.xy.getAreaInSquareRadius(1)) {
			if (!board.isInBounds(neighborXY)) continue;
			for (const thing of board.getThingsAt(neighborXY)) {
				if (thing instanceof PhysicalThingWithHp && thing !== this && thing.active) {
					thing.applyDamage(DamageType.EXPLOSION, STD_BASE_HP, this);
				}
			}
		}
	}

	static deserialize(data: any): ExplosiveBarrel {
		const b = new ExplosiveBarrel(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
